import { PAYMENT_TYPES } from '@constants/app.constants';

// For a partner who configured no default, an online gateway is never auto-selected — selecting one
// unasked submits the customer to it with no action on their part — while a lone offline method is
// safe to select. A partner who DID configure a default asked for a pre-selection, so they get one
// even when that method is switched off; there the first offered method wins, gateway or not.
const AUTO_SELECT_SINGLE_TYPES: string[] = [
  PAYMENT_TYPES.INVOICE,
  PAYMENT_TYPES.EXTERNAL_INVOICE,
  PAYMENT_TYPES.STORE,
  PAYMENT_TYPES.LEX_OFFICE_INVOICE
];

export function resolvePreselectedPaymentType(enabledPaymentTypes: string[], defaultPaymentType: string): string {
  if (defaultPaymentType && enabledPaymentTypes.includes(defaultPaymentType)) {
    return defaultPaymentType;
  }
  // A partner who configured a default that is currently switched off still gets a
  // pre-selection — the first method the checkout offers — rather than an empty one.
  if (defaultPaymentType && enabledPaymentTypes.length) {
    return enabledPaymentTypes[0];
  }
  if (enabledPaymentTypes.length === 1 && AUTO_SELECT_SINGLE_TYPES.includes(enabledPaymentTypes[0])) {
    return enabledPaymentTypes[0];
  }
  return undefined;
}
